import { render, staticRenderFns } from "./Adv.vue?vue&type=template&id=0d0237c2&scoped=true&"
import script from "./Adv.vue?vue&type=script&lang=js&"
export * from "./Adv.vue?vue&type=script&lang=js&"
import style0 from "./Adv.vue?vue&type=style&index=0&id=0d0237c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0237c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d0237c2')) {
      api.createRecord('0d0237c2', component.options)
    } else {
      api.reload('0d0237c2', component.options)
    }
    module.hot.accept("./Adv.vue?vue&type=template&id=0d0237c2&scoped=true&", function () {
      api.rerender('0d0237c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/common/components/Adv.vue"
export default component.exports